import type { Block, VideoBlockContent } from '@/types';
import { resolveVideoEmbedUrl } from '@/lib/videoEmbed';

interface VideoBlockProps {
  block: Block;
}

function VideoBlock({ block }: VideoBlockProps) {
  const content = block.content as VideoBlockContent;

  if (!content.url) {
    return (
      <div className="p-4 border-2 border-dashed border-gray-300 text-center text-muted-foreground">
        Voeg een video-URL toe (YouTube, Vimeo, Vidyard) of neem een video op in het eigenschappenpaneel
      </div>
    );
  }

  const url = content.url;
  const embedUrl = resolveVideoEmbedUrl(url);

  return (
    <div>
      {content.title ? (
        <h3 className="text-base font-medium mb-2">{content.title}</h3>
      ) : null}

      {embedUrl ? (
        <iframe
          src={embedUrl}
          className="w-full aspect-video border-0 rounded"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={content.title || 'Video'}
        />
      ) : (
        <p className="text-sm">
          Video: <a href={url} target="_blank" rel="noreferrer" className="text-primary underline">{url}</a>
        </p>
      )}
    </div>
  );
}

export default VideoBlock;
